import React from 'react'
import './BusinessDigitalCard.css'
import BusinessDigitalBanner from './BusinessDigitalBanner'
import WhatNeoBusinessCard from './WhatNeoBusinessCard'
import BusinessCardBenefits from './BusinessCardBenefits'
import BusinessCardWorks from './BusinessCardWorks'
import BusinessCardRapid from './BusinessCardRapid'
import SeoGeneral from '../BusinessPage/SeoGeneral';

const BusinessDigitalCard = () => {

  const seoMetaData = {
    title: "About NeooCard – Free Smart Digital Business Card | NeooSearch",
    description: "NeooCard digital business card helps you share social links, QR codes, and website links while tracking analytics to build meaningful connections.",
    ogImage: "https://neoosearch.com/static/media/Admin_chat%20logo.7fa36f039461d205a125.png",
    ogImageAlt: "NeooSearch Business Digital Card",
    url: process.env.REACT_APP_APPLICATION_URL + "/about-neoocard",
    keywords: "Paperless business card for networking in UAE, Eco friendly business card, NFC Digital business card UAE and India, Virtual business card, Online business card Dubai, Smart digital business card Dubai, Sharjah and Ajman, QR code business card, Digital business card for professionals in GCC,",
    type: "website",
    site_name: "NeooSearch",
    canonical: process.env.REACT_APP_APPLICATION_URL + "/about-neoocard"
  };
  return (
    <>
      <SeoGeneral data={seoMetaData} />
      <div className='cust_container' >
        <BusinessDigitalBanner />
        <WhatNeoBusinessCard />
        <BusinessCardBenefits />
        <BusinessCardWorks />
        <BusinessCardRapid />
      </div>
    </>
  )
}

export default BusinessDigitalCard